import React from "react";

/* Minimal inline-SVG icon set for the redesign kit — self-contained (no icon
   library dependency), stroke = currentColor so icons inherit text color. */

function Svg({ size = 16, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const SearchIcon = (p) => (
  <Svg {...p}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.5" y2="16.5" />
  </Svg>
);

export const PlusIcon = (p) => (
  <Svg {...p}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </Svg>
);

export const XIcon = (p) => (
  <Svg {...p}>
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </Svg>
);

export const CheckIcon = (p) => (
  <Svg {...p}>
    <polyline points="4 12.5 10 18.5 20 6.5" />
  </Svg>
);

export const ChevronDownIcon = (p) => (
  <Svg {...p}>
    <polyline points="6 9 12 15 18 9" />
  </Svg>
);

export const ChevronLeftIcon = (p) => (
  <Svg {...p}>
    <polyline points="15 6 9 12 15 18" />
  </Svg>
);

export const ChevronRightIcon = (p) => (
  <Svg {...p}>
    <polyline points="9 6 15 12 9 18" />
  </Svg>
);

export const HomeIcon = (p) => (
  <Svg {...p}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V21h14V9.5" />
  </Svg>
);

export const BookIcon = (p) => (
  <Svg {...p}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5v14z" />
    <path d="M4 19.5A2.5 2.5 0 0 0 6.5 22H20v-5" />
  </Svg>
);

export const PipelineIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="4" width="5" height="16" rx="1" />
    <rect x="10" y="4" width="5" height="10" rx="1" />
    <rect x="17" y="4" width="4" height="13" rx="1" />
  </Svg>
);

export const ServiceIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="12" cy="12" r="3.5" />
    <line x1="12" y1="3" x2="12" y2="8.5" />
    <line x1="12" y1="15.5" x2="12" y2="21" />
    <line x1="3" y1="12" x2="8.5" y2="12" />
    <line x1="15.5" y1="12" x2="21" y2="12" />
  </Svg>
);

export const DollarIcon = (p) => (
  <Svg {...p}>
    <line x1="12" y1="2.5" x2="12" y2="21.5" />
    <path d="M16.5 6.5H10a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6H7" />
  </Svg>
);

export const UsersIcon = (p) => (
  <Svg {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
    <path d="M16 5a3.5 3.5 0 0 1 0 7" />
    <path d="M17.5 13.6A6.5 6.5 0 0 1 21.5 20" />
  </Svg>
);

export const BuildingIcon = (p) => (
  <Svg {...p}>
    <rect x="4" y="3" width="16" height="18" rx="1" />
    <line x1="4" y1="21" x2="20" y2="21" />
    <path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2" />
  </Svg>
);

export const GiftIcon = (p) => (
  <Svg {...p}>
    <rect x="3" y="8" width="18" height="4" />
    <rect x="5" y="12" width="14" height="9" />
    <line x1="12" y1="8" x2="12" y2="21" />
    <path d="M12 8s-4.5 0-5.5-2S8 2.5 9.5 3.5 12 8 12 8zM12 8s4.5 0 5.5-2S16 2.5 14.5 3.5 12 8 12 8z" />
  </Svg>
);

/* Custodian sweep — a sparkle for the Data-fixes nav (§10.7b). */
export const SparkleIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z" />
    <path d="M18 14l.8 2.2L21 17l-2.2.8L18 20l-.8-2.2L15 17l2.2-.8L18 14z" />
  </Svg>
);

export const SwatchIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3H5a1 1 0 0 0-1 1v13a4 4 0 0 0 8 0V4a1 1 0 0 0 0 0z" />
    <path d="M12 17.5 17.7 11a1 1 0 0 0 0-1.4l-4.2-4.2" />
    <path d="M8 21h11a1 1 0 0 0 1-1v-6" />
    <circle cx="8" cy="17" r="0.5" />
  </Svg>
);

export const LogoutIcon = (p) => (
  <Svg {...p}>
    <path d="M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4" />
    <polyline points="10 8 6 12 10 16" />
    <line x1="6" y1="12" x2="16" y2="12" />
  </Svg>
);

export const ExternalIcon = (p) => (
  <Svg {...p}>
    <path d="M14 4h6v6" />
    <line x1="20" y1="4" x2="11" y2="13" />
    <path d="M19 14v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5" />
  </Svg>
);

export const InboxIcon = (p) => (
  <Svg {...p}>
    <path d="M3 13.5 6 5h12l3 8.5" />
    <path d="M3 13.5h5.5a3.5 3.5 0 0 0 7 0H21V19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5.5z" />
  </Svg>
);

export const AlertIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3 2.5 20h19L12 3z" />
    <line x1="12" y1="9.5" x2="12" y2="14" />
    <circle cx="12" cy="17" r="0.5" />
  </Svg>
);

export const ShieldIcon = (p) => (
  <Svg {...p}>
    <path d="M12 2.5 4.5 5.5v6c0 4.5 3 8.5 7.5 10 4.5-1.5 7.5-5.5 7.5-10v-6L12 2.5z" />
  </Svg>
);

export const CommandIcon = (p) => (
  <Svg {...p}>
    <path d="M9 9V6a3 3 0 1 0-3 3h3zm0 0v6m0-6h6m-6 6H6a3 3 0 1 0 3 3v-3zm6-6V6a3 3 0 1 1 3 3h-3zm0 0v6m0 0h3a3 3 0 1 1-3 3v-3z" />
  </Svg>
);

export const CarIcon = (p) => (
  <Svg {...p}>
    <path d="M4 16v-4l2-6h12l2 6v4" />
    <path d="M4 12h16" />
    <path d="M3 16h18v3h-2.5" />
    <circle cx="7.5" cy="17.5" r="1.8" />
    <circle cx="16.5" cy="17.5" r="1.8" />
  </Svg>
);

export const UmbrellaIcon = (p) => (
  <Svg {...p}>
    <path d="M12 3a9 9 0 0 1 9 9H3a9 9 0 0 1 9-9z" />
    <path d="M12 12v7a2 2 0 0 0 4 0" />
    <line x1="12" y1="2" x2="12" y2="3" />
  </Svg>
);

export const FileIcon = (p) => (
  <Svg {...p}>
    <path d="M6 2.5h8L19 8v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-18a1 1 0 0 1 1-.5z" />
    <polyline points="14 2.5 14 8 19 8" />
  </Svg>
);

export const ClockIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15.5 14" />
  </Svg>
);

export const KebabIcon = (p) => (
  <Svg {...p}>
    <circle cx="12" cy="5" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="12" cy="19" r="1" />
  </Svg>
);
